import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const PartnerStudentVariationGauge = (props) => (
  <KpiChart
    title="Growth of students studying"
    description="The number represents the percentage of students that studied in the month period compared to the previous month."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[-10, -5, 0, 5, 10]}
    stepSize={5}
    reverseColors={false}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

PartnerStudentVariationGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

PartnerStudentVariationGauge.defaultProps = {
  onClickHistory: null,
};

export default PartnerStudentVariationGauge;
